import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarCuposSinConsumir } from '../actions/TablaCuposSinConsumirActions'
import TablaConsultaCodigoDeCuposView from '../../../../Cupos/containers/consultaCodigoDeCupos/components/TablaConsultaCodigoDeCuposView'

function TablaCuposSinConsumir (props) {
  const { filtroInicial, fechaD, fechaH, cereal, actualizarCuposSinConsumir } = props

  useEffect(() => {
    actualizarCuposSinConsumir(fechaD, fechaH, cereal, filtroInicial)
  }, [actualizarCuposSinConsumir, cereal, fechaD, fechaH, filtroInicial])

  return (
    <TablaConsultaCodigoDeCuposView />
  )
}

const mapActionsToProps = ({
  actualizarCuposSinConsumir
})

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCuposSinConsumir)
